/**
 * ------------------------------------------------------------
 * NLS Anchor Scroll
 * Intercepta clics en enlaces con hash a secciones concretas
 * de la home y aplica scroll suave inteligente.
 * ------------------------------------------------------------
 */
(function () {
  'use strict';

  var TARGETS = {
    'shopify-section-nls_collections_showcase': 'collections',
    'shopify-section-collapsible_content_Gx3nQM': 'faq'
  };

  function getHeaderHeight() {
    var header = document.querySelector('sticky-header, .header-wrapper, .site-header, header');
    if (!header) return 0;
    var rect = header.getBoundingClientRect();
    if (rect.top >= -5 && rect.height > 0 && rect.height < window.innerHeight) {
      return rect.height;
    }
    return 0;
  }

  function scrollToCollections(target) {
    var headerHeight = getHeaderHeight();
    var womenCell = target.querySelector('.nls-showcase__cell--women');
    var menCell = target.querySelector('.nls-showcase__cell--men');
    var targetTop;

    if (womenCell && menCell) {
      var womenRect = womenCell.getBoundingClientRect();
      var menRect = menCell.getBoundingClientRect();
      var womenTop = womenRect.top + window.pageYOffset;
      var menTop = menRect.top + window.pageYOffset;
      targetTop = menTop - (window.innerHeight / 2);
      var maxScroll = womenTop - headerHeight - 20;
      if (targetTop < maxScroll) targetTop = maxScroll;
    } else {
      targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
    }

    window.scrollTo({ top: targetTop, behavior: 'smooth' });
  }

  function scrollToFaq(target) {
    var headerHeight = getHeaderHeight();
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function performScroll(sectionId) {
    var target = document.getElementById(sectionId);
    if (!target) return false;
    var kind = TARGETS[sectionId];
    if (kind === 'collections') {
      scrollToCollections(target);
    } else if (kind === 'faq') {
      scrollToFaq(target);
    } else {
      var headerHeight = getHeaderHeight();
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
    return true;
  }

  function extractSectionIdFromHref(href) {
    if (!href) return null;
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return null;
    var hash = href.substring(hashIndex + 1);
    return TARGETS.hasOwnProperty(hash) ? hash : null;
  }

  function isSameOriginHomeLink(anchor) {
    var href = anchor.getAttribute('href') || '';
    if (href.charAt(0) === '#') return true;
    if (href.charAt(0) === '/' && (href.charAt(1) === '#' || href === '/' || href.indexOf('/#') === 0)) return true;
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return false;
      return url.pathname === '/' || url.pathname === '';
    } catch (e) {
      return false;
    }
  }

  function isCurrentlyOnHome() {
    return window.location.pathname === '/' || window.location.pathname === '';
  }

  function handleClick(e) {
    if (e.defaultPrevented) return;
    if (e.button && e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var anchor = e.target.closest ? e.target.closest('a[href]') : null;
    if (!anchor) return;
    var href = anchor.getAttribute('href');
    var sectionId = extractSectionIdFromHref(href);
    if (!sectionId) return;
    if (isCurrentlyOnHome() && isSameOriginHomeLink(anchor)) {
      e.preventDefault();
      if (window.history && window.history.replaceState) {
        try { window.history.replaceState(null, '', '#' + sectionId); } catch (err) { /* noop */ }
      }
      performScroll(sectionId);
    }
  }

  function handleLoad() {
    if (!isCurrentlyOnHome()) return;
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var sectionId = hash.substring(1);
    if (!TARGETS.hasOwnProperty(sectionId)) return;
    var attempts = 0;
    var maxAttempts = 10;
    function tryScroll() {
      var ok = performScroll(sectionId);
      if (!ok && attempts < maxAttempts) { attempts++; setTimeout(tryScroll, 100); }
    }
    setTimeout(function () {
      window.scrollTo({ top: 0, behavior: 'auto' });
      setTimeout(tryScroll, 50);
    }, 0);
  }

  document.addEventListener('click', handleClick, false);

  if (document.readyState === 'complete') {
    handleLoad();
  } else {
    window.addEventListener('load', handleLoad, { once: true });
  }
})();

/**
 * ------------------------------------------------------------
 * NLS Deferred Tracking  (añadido 16-sep-2026)
 *
 * Retrasa Klaviyo y Clarity para que el pixel de Meta dispare
 * el PageView cuanto antes.
 * ------------------------------------------------------------
 */
(function () {
  'use strict';

  var KLAVIYO_COMPANY_ID = 'UyfLdm';
  var CLARITY_TAG = 'y3et307cn7';
  var CLARITY_SAMPLE_RATE = 0.2;
  var CLARITY_BUCKET_KEY = 'nls_clarity_bucket';
  var done = false;

  function loadKlaviyo() {
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://static.klaviyo.com/onsite/js/' + KLAVIYO_COMPANY_ID + '/klaviyo.js?company_id=' + KLAVIYO_COMPANY_ID;
    document.head.appendChild(s);
  }

  function inClaritySample() {
    try {
      var bucket = window.localStorage.getItem(CLARITY_BUCKET_KEY);
      if (bucket === null) {
        bucket = Math.random() < CLARITY_SAMPLE_RATE ? '1' : '0';
        window.localStorage.setItem(CLARITY_BUCKET_KEY, bucket);
      }
      return bucket === '1';
    } catch (e) {
      return Math.random() < CLARITY_SAMPLE_RATE;
    }
  }

  function loadClarity() {
    if (!inClaritySample()) return;
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', CLARITY_TAG);
  }

  function loadDeferred() {
    if (done) return;
    done = true;
    loadKlaviyo();
    loadClarity();
  }

  var INTERACTIONS = ['scroll', 'mousemove', 'touchstart', 'keydown', 'pointerdown'];

  function onInteraction() {
    INTERACTIONS.forEach(function (evt) { window.removeEventListener(evt, onInteraction); });
    loadDeferred();
  }

  INTERACTIONS.forEach(function (evt) {
    window.addEventListener(evt, onInteraction, { passive: true });
  });

  setTimeout(loadDeferred, 8000);

  if (document.readyState === 'complete') {
    setTimeout(loadDeferred, 2500);
  } else {
    window.addEventListener('load', function () { setTimeout(loadDeferred, 2500); }, { once: true });
  }
})();

/**
 * ------------------------------------------------------------
 * NLS Popup → volver a la misma página  (v3, 21-oct-2026)
 *
 * El botón del popup de Klaviyo es un <button> con «Ir a URL»,
 * así que no se puede reescribir su enlace. Klaviyo lleva a
 * /discount/CODIGO?redirect=/?cart=open → Shopify aplica el
 * descuento y manda a la home con ?cart=open.
 *
 * Este bloque:
 *   1. En cada página normal guarda la URL actual (sessionStorage).
 *   2. Al llegar con ?cart=open, devuelve al cliente a esa última
 *      página añadiendo ?nls_popup=1. El snippet
 *      nls-drawer-discount-js detecta ese parámetro, abre el carrito
 *      lateral y muestra el mensaje del 10 % si está vacío.
 * ------------------------------------------------------------
 */
(function () {
  'use strict';

  var LAST_KEY = 'nls_last_page';
  var params = new URLSearchParams(window.location.search);
  var path = window.location.pathname;

  if (params.get('cart') === 'open') {
    var dest = '/';
    try { dest = sessionStorage.getItem(LAST_KEY) || '/'; } catch (e) { /* noop */ }
    var u;
    try { u = new URL(dest, window.location.origin); } catch (e) { u = new URL('/', window.location.origin); }
    if (u.origin !== window.location.origin) u = new URL('/', window.location.origin);
    u.searchParams.delete('cart');
    u.searchParams.set('nls_popup', '1');
    var pv = params.get('preview_theme_id');
    if (pv && !u.searchParams.get('preview_theme_id')) u.searchParams.set('preview_theme_id', pv);
    window.location.replace(u.pathname + u.search + u.hash);
    return;
  }

  var excluded = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(cart|checkout|checkouts|discount|account|apps|challenge|password)(\/|$)/i.test(path);
  if (!excluded) {
    var p = new URLSearchParams(window.location.search);
    p.delete('nls_popup');
    var qs = p.toString();
    try { sessionStorage.setItem(LAST_KEY, path + (qs ? '?' + qs : '') + window.location.hash); } catch (e) { /* noop */ }
  }
})();
